import { Navigate, generatePath } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { OptionI18nEditPresenter } from "./presenter";
import { useOptionI18nEditQuery } from "../../model/repository/existing";

type Props = {
	hotelID: string;
	optionID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const OptionI18nEditContainer = ({ hotelID, optionID, activeLangCode, navigator }: Props) => {
	const serverModel = useOptionI18nEditQuery({ hotelID, optionID, langCode: activeLangCode });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.OPTION.TOP, { hotelID })} />;
	}

	return <OptionI18nEditPresenter activeLangCode={activeLangCode} navigator={navigator} serverModel={serverModel} />;
};

OptionI18nEditContainer.displayName = "OptionI18nEditContainer";
